import { type CarouselTypeOption, CarouselTypeOptions } from '../carouselTypeOptions';
import { SliderHTMLElement } from '../../../../common/slider/slider';

const ATTRIBUTES = [
    'data-carousel-type',
    'data-infinite',
    'data-init-infinite-on-load',
    'data-items-count',
    'data-random',
    'data-theme',
    'data-carousel-autoplay',
    'data-carousel-autoplay-interval',
    'data-carousel-pauseonhover',
    'data-edit-mode',
];

export class CardCarouselHTMLElement extends SliderHTMLElement {
    private carouselTypeOption: CarouselTypeOption;

    constructor() {
        super({
            containerSelector: '.carousel-items-container',
            currentSlideIndex: 1,
            indicatorSelector: '.carousel-indicator',
            itemsContainerSelector: '.carousel-items',
            itemSelector: '.carousel-item',
            nextNavSelector: '.carousel-control-next',
            prevNavSelector: '.carousel-control-prev',
        });
        this.initInfiniteOnLoad = false;
        this.startingSlideIndex = 1;
    }

    static get observedAttributes(): string[] {
        return ATTRIBUTES;
    }

    public attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
        if (!ATTRIBUTES.includes(name)) {
            return;
        }
        if (oldValue === newValue) {
            return;
        }

        super.attributeChangedCallback(name, oldValue, newValue);

        setTimeout(() => {
            switch (name) {
                case 'data-carousel-type': {
                    const typeReset = this.carouselTypeOption !== undefined;
                    this.carouselTypeOption = CarouselTypeOptions.find((option: CarouselTypeOption) => option.value === newValue);
                    this.currentSlideCentered = this.carouselTypeOption.centered;
                    this.fullWSlide = this.carouselTypeOption.fullW;
                    this.sliderType = `CardCarousel - ${this.carouselTypeOption.label}`;
                    this.reset(typeReset ? this.startingSlideIndex : undefined);
                    break;
                }
                case 'data-infinite':
                    this.infinite = newValue === 'true';
                    oldValue === 'true' && this.infiniteConfigured && this.cleanUpInfinite();
                    newValue === 'true' && this.initInfiniteOnLoad && this.setUpInfinite();
                    break;
                case 'data-init-infinite-on-load':
                    this.initInfiniteOnLoad = newValue === 'true';
                    oldValue === 'true' && this.infiniteConfigured && this.cleanUpInfinite();
                    newValue === 'true' && this.infinite && this.setUpInfinite();
                    break;
                case 'data-items-count':
                    this.itemsTotal = Number.parseInt(newValue);
                    this.reset(this.startingSlideIndex);
                    break;
                case 'data-random':
                    newValue === 'true' ? this.setRandomSlide() : this.restoreSliderBehavior();
                    break;
                case 'data-carousel-autoplay-interval':
                    this.autoplayInterval = Number.parseInt(newValue);
                    if (this.autoplay) {
                        this.disableAutoplay();
                        this.enableAutoplay();
                    }
                    break;
                case 'data-carousel-pauseonhover':
                    this.autoplayPauseOnHover = newValue === 'true'
                    this.autoplayPauseOnHover ? this.enablePauseOnHover() : this.disablePauseOnHover();
                    break;
                case 'data-carousel-autoplay':
                    this.autoplay = newValue === 'true';
                    this.autoplay ? this.enableAutoplay() : this.disableAutoplay();
                    break;
                case 'data-theme':
                    if (oldValue !== null) {
                        this.reset();
                    }
                    break;
                default:
                    break;
            }
        })
    }
}
